import React, { memo } from 'react'
import classnames from 'classnames'
import './ScheduledLivestreamBanner.css'
import { Countdown } from "../../countdown/Countdown";
import {useStateValue} from "../../state-provider/StateProvider";


const ScheduledLivestreamBannerComponent: React.FC<{

}> = ({

}) => {

  const [{ isWidgetMaximized, gridAreaContent }] = useStateValue()

  return (
    <>
      { !isWidgetMaximized && (
        <>
          { gridAreaContent === 'LiveStreamReminderForm' && (

            <div className={classnames('scheduled-livestream')}>
              <Countdown />
            </div>
          )}
        </>
      )}
    </>
  )
}

export const ScheduledLivestreamBanner = memo(ScheduledLivestreamBannerComponent)
